import React from 'react';
import Chart from 'react-apexcharts';
import { useTheme } from '@mui/material/styles';

const ContractsHistogram = ({ contracts, metricKey, title, xAxisTitle, color, valueType = 'count' }) => {
    const theme = useTheme();
    const maxBuckets = valueType === 'percentage' ? 100 : 20;

    const values = contracts.map(contract => {
        if (valueType !== 'percentage') {
            return contract.cached?.[metricKey] ?? 0;
        }

        const clauseCount = contract.cached?.clauseCount ?? 0;
        if (clauseCount === 0) return 0;

        return Math.round(((contract.cached?.[metricKey] ?? 0) / clauseCount) * 100);
    });
    const maxValue = Math.max(...values, 0);
    const bucketSize = maxValue + 1 > maxBuckets ? Math.ceil((maxValue + 1) / maxBuckets) : 1;
    const bucketCount = Math.min(maxBuckets, Math.ceil((maxValue + 1) / bucketSize));
    const buckets = Array.from({ length: bucketCount }, (_, index) => {
        const start = index * bucketSize;
        const end = Math.min(start + bucketSize - 1, maxValue);

        return {
            start,
            end,
            label: valueType === 'percentage'
                ? start === end ? `${start}%` : `${start}-${end}%`
                : start === end ? `${start}` : `${start}-${end}`,
            count: 0
        };
    });

    values.forEach(value => {
        const bucketIndex = Math.min(Math.floor(value / bucketSize), buckets.length - 1);
        buckets[bucketIndex].count += 1;
    });

    const categories = buckets.map(bucket => bucket.label);
    const counts = buckets.map(bucket => bucket.count);

    const chartColor = color || theme.palette.primary.main;

    return (
        <Chart
            options={{
                chart: {
                    type: 'bar',
                    toolbar: { show: true }
                },
                plotOptions: {
                    bar: {
                        columnWidth: '55%',
                        borderRadius: 4
                    }
                },
                xaxis: {
                    categories,
                    title: { text: xAxisTitle }
                },
                yaxis: {
                    title: { text: 'Anzahl Verträge' },
                    min: 0,
                    forceNiceScale: true
                },
                colors: [chartColor],
                dataLabels: { enabled: false },
                title: {
                    text: title,
                    align: 'center'
                }
            }}
            series={[{ name: 'Verträge', data: counts }]}
            type="bar"
            height={350}
        />
    );
};

export default ContractsHistogram;
